/**
 * Nom des types de mission, ex : Formation longue, soutient, etc
 */
export enum MissionTypeName {
	FORMATION_LONGUE = 'Formation longue',
	PRESTATION_COURTE_PPS = 'Prestation courte PPS',
	PRESTATION_PAYANTE = 'Prestation payant',
	SOUTIEN = 'Soutien',
	REUNION = 'Réunion',
	VISITE = 'Visite',
	MISSION_ITC = 'Mission ITC',
	MISSION_TRE = 'Mission TRE',
	MISSION_ANNEXE = 'Mission annexe (SACSO, EHPAD, ...)',
	// SAE
	PRESCRIPTION = 'Prescription', // SAE
	QD = 'QUALIFICATION DE LA DEMANDE',
	AS = 'ANALYSE DE LA SITUATION',
	AC = 'ANALYSE DES CAPACITES',
	EAP = 'EVALUATION APPROFONDIE AVEC PRECONISATIONS',
	CAMEO = 'CONSEIL ET APPUI A LA MISE EN OEUVRE « VERS L’EMPLOI » - « DANS L’EMPLOI » - « EN SITUATION DE FORMATION »',
	SP = 'SUIVI DES PRECONISATIONS'
}
